import { Construction } from 'lucide-react';

import { Button } from '@/shared/components/ui/Button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/ui/Dialog';

interface UnderConstructionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  featureName: string;
}

export function UnderConstructionDialog({
  open,
  onOpenChange,
  featureName,
}: UnderConstructionDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm text-center">
        <DialogHeader className="items-center">
          <div className="bg-primary/10 mx-auto flex h-14 w-14 items-center justify-center rounded-full">
            <Construction className="text-primary h-7 w-7" />
          </div>
          <DialogTitle className="mt-3">Under Construction</DialogTitle>
        </DialogHeader>
        <p className="text-muted-foreground text-sm">
          <strong>{featureName}</strong> is currently under development and will be available soon.
        </p>
        <DialogFooter className="sm:justify-center">
          <Button
            onClick={() => {
              onOpenChange(false);
            }}
          >
            Got it
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
